import React from "react";

const UserAvatar = ({ size = 56 }: { size?: number; color?: string }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width={size} height={size} rx="20" fill="#1A0A91" />
		<path
			d="M25.4297 28.9221V26.9489C25.4297 26.3059 25.1743 25.6893 24.7197 25.2347C24.2651 24.78 23.6485 24.5246 23.0055 24.5246H17.0859C16.4429 24.5246 15.8263 24.78 15.3716 25.2347C14.917 25.6893 14.6616 26.3059 14.6616 26.9489V28.9221C14.6616 29.7627 13.9801 30.4443 13.1394 30.4443C12.2987 30.4443 11.6172 29.7627 11.6172 28.9221V26.9489C11.6172 25.4985 12.1933 24.1075 13.2189 23.0819C14.2445 22.0564 15.6355 21.4802 17.0859 21.4802H23.0055C24.4559 21.4802 25.8468 22.0564 26.8724 23.0819C27.8979 24.1075 28.4741 25.4985 28.4741 26.9489V28.9221C28.4741 29.7627 27.7926 30.4443 26.9519 30.4443C26.1112 30.4442 25.4297 29.7627 25.4297 28.9221ZM22.4699 15.1095C22.4699 13.7707 21.3845 12.6853 20.0457 12.6853C18.7068 12.6853 17.6214 13.7707 17.6214 15.1095C17.6214 16.4484 18.7068 17.5337 20.0457 17.5337C21.3845 17.5337 22.4699 16.4484 22.4699 15.1095ZM25.5143 15.1095C25.5143 18.1298 23.0659 20.5781 20.0457 20.5781C17.0254 20.5781 14.577 18.1298 14.577 15.1095C14.577 12.0893 17.0254 9.64087 20.0457 9.64087C23.0659 9.64088 25.5143 12.0893 25.5143 15.1095Z"
			fill="white"
		/>
	</svg>
);

export default UserAvatar;
